const styles = (theme) => ({
	modal: {
		position: "absolute",
		borderRadius: "16px",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: " 90%",
		maxWidth: "1000px",
		bgcolor: "background.paper",
		boxShadow: 24,
		px: 4,
		pb: 4,
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		py: 3,
		alignItems: "center",
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
	},
	paperInternal: {
		bgcolor: "background.wallpaper",
		p: 2,
		borderRadius: "16px",
		maxHeight: "70vh",
		overflow: "auto",
		border: theme.palette.mode === "light" && "none",
	},
	containerButton: {
		display: "flex",
		justifyContent: "space-between",
		pt: 2,
		mx: 2,
	},
});

export default styles;
